//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GeometricUtilities.UVMapping.js";
import "../no/Builder.js";
import "../no/ScCollector.js";
import "../no/SelectEdge.js";
import "../no/Section.js";
import "../no/SelectTaggedObject.js";
import "../no/ScCollector.js";
import "../no/Section.js";
import "../no/SelectObject.js";
let d=[[[0,"ConstraintOption",1,0],[1,"Faces",0,"ScCollector",0],[0,"NumberOfGridLines",1,0],[1,"OuterBoundarySeedEdge",0,"SelectEdge",0],[1,"RipEdges",0,"Section",0],[0,"TessellationResolution",1,0],[0,"Type",1,0],[1,"U1Edges",0,"ScCollector",0],[1,"U2Edges",0,"ScCollector",0],[1,"UDirectionCurve",0,"SelectTaggedObject",0],[1,"V1Edges",0,"ScCollector",0],[1,"V2Edges",0,"ScCollector",0]],[[[],"Evaluate",{},0,0]],[]];
SPLM.GeometricUtilities.UVMapping.UVParameterizationBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.GeometricUtilities.UVMapping.UVParameterizationBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.GeometricUtilities.UVMapping.UVParameterizationBuilder.ParameterizationTypes = Object.freeze({
    "ShapePreserving" : "ShapePreserving", "LengthPreserving" : "LengthPreserving", "Generic" : "Generic", "Cylindrical" : "Cylindrical"});

SPLM.GeometricUtilities.UVMapping.UVParameterizationBuilder.ConstraintOptions = Object.freeze({
    "None" : "None", "Edges" : "Edges"});

SPLM.GeometricUtilities.UVMapping.UVParameterizationBuilder.TessellationResolutions = Object.freeze({
    "Coarse" : "Coarse", "Standard" : "Standard", "Fine" : "Fine", "ExtraFine" : "ExtraFine"});

export default SPLM;